import { FoodLogModel } from './../object/foodlog-model';
export class DietsListResponse {
  constructor(
    public success: boolean,
    public categories: DietsListCategory[]
  ) {}
}

export class DietsListCategory {
  constructor(
    public createdAt: string,
    public name: string,
    public _id: string,
    public dietTypes: DietsListDietType[]
  ) {}
}

export class DietsListDietType {
  constructor(
    public createdAt: string,
    public days: number,
    public description: string,
    public fasting: number,
    public id: string,
    public image: string,
    public isPersonal: boolean,
    public name: string,
    public type: string
  ) {}
}

export class packageSuggester {
  constructor(
    public success: boolean,
    public message_id: number,
    public count: number,
    public packages: packages[]
  ) {}
}
export class packages {
  constructor(
    public _id: string,
    public category: string,
    public recommended: number,
    public deleted: number,
    public meal: string,
    public foods: packagesFood[],
    public createdAt: string,
    public updatedAt: string,
    public __v: number,
    public types: string[],
    public amounts: { amount: number }[]
  ) {}
}
export class packagesFood {
  constructor(
    public _id: string,
    public foodId: {
      _id: string;
      name: string;
      amount?: number;
      suitableDiseases: string[];
      notSuitableDiseases: string[];
      suitableSpecialTypes: string[];
      notSuitableSpecialTypes: string[];
      seasons: string[];
      notSuitableTypes: string[];
      hatedFoods: string[];
      deleted: boolean;

      primaryFoodUnit: string;
      primaryFoodUnitCalorie: number;
      foodFact: {
        calorieAmount: number;
        proteinAmount: number;
        fatAmount: number;
        carbohydrateAmount: number;
        sugarAmount: number;
        fiberAmount: number;
        sodiumAmount: number;
        potassiumAmount: number;
        calciumAmount: number;
        magnesiumAmount: number;
        ironAmount: number;
        cholesterolAmount: number;
        phosphorAmount: number;
        saturatedFatAmount: number;
        polyunsaturatedFatAmount: number;
        transFatAmount: number;
        monounsaturatedFatAmount: number;
        _id: string;
        createdAt: string;
        updatedAt: string;
      };
      foodUnitRatioArray: [
        {
          ratio: number;
          _id: string;
          unitId: {
            _id: string;
            name: string;
            deleted: boolean;
            createdAt: string;
            updatedAt: string;
            __v: number;
          };
          createdAt: string;
          updatedAt: string;
        }
      ];
      createdAt: string;
      updatedAt: string;
      __v: number;
      notSuitableBreastfeeding: boolean;
      notSuitablePregnancy: boolean;
      recipe?: string;
    }
  ) {}
}

export class ExerciseSearchResponce {
  constructor(
    public success: boolean,
    public message_id: number,
    public statusCode: number,
    public exercises: ExerciseItem[],
    public count: number
  ) {}
}
export class ExerciseItem {
  constructor(
    public _id: string,
    public deleted: false,
    public name: string,
    public met: number,
    public createdAt: string,
    public updatedAt: string
  ) {}
}

export class ResponseDayLogs {
  constructor(
    public foodLogs: FoodLogModel[],
    public deletedFoodLogs: FoodLogModel[],
    public exerciseLogs: ResponseDayExerciseLogs[],
    public deletedExerciseLogs: string[],
    public success: boolean,
    public message_id: number,
    public statusCode: number
  ) {}
}
export class ResponseDayExerciseLogs {
  constructor(
    public calorie: number,
    public createdAt: string,
    public date: number,
    public deleted: boolean,
    public duration: number,
    public name: string,
    public updatedAt: string,
    public user: string,
    public _id: string,
    public exercise?: {
      _id: string;
      name: string;
    }
  ) {}
}
